import ArrowDropUpRoundedIcon from '@mui/icons-material/ArrowDropUpRounded';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';

export const TableHeader = ({ headerData, clickSortData, selectedSort, sortData }) => (
	<div className="orders-table-header">
		{headerData.map((value, index) => (
			<div key={index} className="child" style={{ "--width": value.width_table + "%", cursor: ["No", "Posting_Date"].includes(value.id)  ? "pointer" : "auto" }} onClick={() => clickSortData(value.id, sortData[value.id] ? sortData[value.id].sort : "")}>
				<div className="text">{value.name}</div>
				<div className="header-sort">
					{selectedSort === value.id && value.id !== "Action" && selectedSort !== "Value" ?
						sortData[value.id].sort === "desc" ?
							<ArrowDropUpRoundedIcon className={`sort-data top ${sortData[value.id].sort === "desc" ? "selected" : ""}`} />
							:
							<ArrowDropDownRoundedIcon className={`sort-data bottom ${sortData[value.id].sort === "asc" ? "selected" : ""}`} />
						:
						selectedSort === value.id && value.id !== "Action" && selectedSort === "Value" ?
							sortData[value.id].sort === "asc" ?
								<ArrowDropUpRoundedIcon className={`sort-data top ${sortData[value.id].sort === "desc" ? "selected" : ""}`} />
								:
								<ArrowDropDownRoundedIcon className={`sort-data bottom ${sortData[value.id].sort === "asc" ? "selected" : ""}`} />
							: ''
					}
				</div>
			</div>
		))}
	</div>
);